import { enqueueActions } from 'xstate';

import { diffPromotedIngredients, optimizeIncludedSlots as optimize } from '../../helpers';
import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * After any modification change, ensures extras are moved into free
 * included slots and originally-included items reclaim their slots
 * from downgraded guests.
 *
 * Also surfaces the promoted ingredients (if any) via the `onIngredientsSwapped` action
 * so the host can show a "...your bowl is priced at its best" message.
 */
export const optimizeIncludedSlots: CustomizationMachineAction = enqueueActions((args) => {
  const { enqueue, context } = args;

  const {
    includedModificationsMap,
    extrasModificationsMap,
    includedModifierGroupsByExtrasName,
    modificationLimits,
    modifications,
    isUpsellPricingEnabled,
  } = context;

  if (!isUpsellPricingEnabled || !modifications) return;

  const updatedActives = optimize({
    activeModifications: modifications.active,
    initialModifications: modifications.initial,
    includedModificationsMap,
    extrasModificationsMap,
    includedModifierGroupsByExtrasName,
    modificationLimits,
  });

  if (updatedActives === modifications.active) return;

  enqueue.assign({ modifications: { ...modifications, active: updatedActives } });

  const promotions = diffPromotedIngredients({
    before: modifications.active,
    after: updatedActives,
  });

  if (promotions.length === 0) {
    return;
  }

  enqueue({ type: 'onIngredientsSwapped', params: { promotions } });
});
